export default {
    welcome: 'Willkommen!',
    completeRegistration: ' Vervollständigen Sie Ihre Daten und schließen Sie die Registrierung ab.',
    selectNewPassword: 'Wählen Sie ein neues sicheres Passwort, welches folgende Kriterien erfüllt:'
}